import { useBlocker } from "../../contexts";
import { BlockerHeaderInlineStyles } from ".";
import { getOtherOptionsFromWindow } from "../../utils";

var BlockerHeader = function BlockerHeader() {
  var blocker = useBlocker();
  var name = blocker.blocker.name;

  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      blockedContentHeadline = _getOtherOptionsFromW.bannerI18n.blockedContentHeadline;

  return h("div", BlockerHeaderInlineStyles.headerContainer(blocker), h("div", BlockerHeaderInlineStyles.header(blocker), h("div", BlockerHeaderInlineStyles.headline(blocker), blockedContentHeadline.replace(/%1\$s/g, name))));
};

export { BlockerHeader };